'use client';

import React from 'react';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import { DashboardLayout } from '@/components/layout';
import GrowthInteractive from '@/features/growth/components/GrowthInteractive';

export default function GrowthPage() {
    return (
        <ProtectedRoute>
            <DashboardLayout>
                <GrowthInteractive />
            </DashboardLayout>
        </ProtectedRoute>
    );
}
